// MAIN

import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Footer from "./components/Footer";
import GlobalStyles from "./components/GlobalStyles";

function App() {
  return (
    <div className="font-sans">
      <GlobalStyles />

      <Header />

      <main>
        <Hero />
        <About />
        <Skills />
        <Projects />
      </main>

      <Footer />
    </div>
  );
}

export default App;
